import React, { useState, useEffect } from "react";
import { Query, useQuery, useApolloClient } from "react-apollo";
import { CURRENT_USER_QUERY } from "../graphql/Users/Users.graphql";

import { ourToast as toast } from "../utils";

export const useAuthorization = roles => {
  const { data, loading, error } = useQuery(CURRENT_USER_QUERY);
  if (loading || error || !data) return false;
  return (
    data &&
    data.Me &&
    data.Me.UserGroupMemberships.some(ship =>
      roles.includes(ship.UserGroup.GroupId)
    )
  );
};

export const useExactAuthorization = roles => {
  const { data, loading, error } = useQuery(CURRENT_USER_QUERY);
  if (loading || error || !data) return false;
  return (
    data &&
    data.Me &&
    data.Me.UserGroupMemberships.every(ship =>
      roles.includes(ship.UserGroup.GroupId)
    )
  );
};

export const useCurrentUserRoles = () => {
  const client = useApolloClient();
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {
          data: {
            Me: { UserGroupMemberships }
          }
        } = await client.query({
          query: CURRENT_USER_QUERY
        });

        if (
          Array.isArray(UserGroupMemberships) &&
          UserGroupMemberships.length
        ) {
          setData(UserGroupMemberships.map(m => m.UserGroup.GroupId));
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchData();
  }, [client]);

  return data;
};
// eslint-disable-next-line
const Authorization = (editRoles, viewRoles = []) => (
  WrappedComponent,
  props
) => (
  <Query fetchPolicy="network-only" query={CURRENT_USER_QUERY}>
    {({ data, loading, error }) => {
      if (loading) return <p>Loading...</p>;
      if (error) {
        toast.error("Error getting Authorization.");
      }
      if (data?.Me) {
        const authorizedRoles = data.Me.UserGroupMemberships.map(
          ship => ship.UserGroup.GroupId
        );
        if (authorizedRoles.some(role => editRoles.includes(role))) {
          return <WrappedComponent {...props} />;
        }
        if (authorizedRoles.some(role => viewRoles.includes(role))) {
          return <WrappedComponent {...props} readOnly />;
        }

        return <p>NOT AUTHORIZED</p>;
      }
    }}
  </Query>
);

export default Authorization;
